import en, { noEmbeddedInput as enNoInput, email as enEmail } from './en';
import ru, { noEmbeddedInput as ruNoInput, email as ruEmail } from './ru';
import uk, { noEmbeddedInput as ukNoInput, email as ukEmail } from './uk';

export const noEmbeddedInputLayouts = {
  en: enNoInput,
  ru: ruNoInput,
  uk: ukNoInput,
};

export const emailLayouts = {
  en: enEmail,
  ru: ruEmail,
  uk: ukEmail,
};

export const searchLayouts = {
  en,
};

export default { en, ru, uk };
